import React from 'react'
import Link from 'next/link'
import { FormattedDate, FormattedMessage } from 'react-intl'
import messages from '../i18n/messages'
import TaskaShkspr from 'assets/img/taska-shkspr.svg'
import { Container } from 'reactstrap'

const dateFormat = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
}

export default ({ org, event, date }) => (
  <Container className="d-flex justify-content-center">
    <div className="feedback-outer-wrap" style={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
      <div className="feedback-wrap">
        <div className="text-center">
          <img className="hero-img" src={TaskaShkspr} alt="" />
          <h2 className="text-primary mt-3 text-uppercase font-weight-bold">
            <FormattedMessage {...messages.cancelled} />
          </h2>
          <div>
            <Link href={`/${org.odn}/e/${event.id}`}>
              <a href={`/${org.odn}/e/${event.id}`}>
                {event.title}
              </a>
            </Link>
          </div>
          <FormattedDate value={date.starts_at} {...dateFormat} />
          <br />
          <div>
            <Link href={`/${org.odn}`}>
              <a href={`/${org.odn}`}>
                {org.name}
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </Container>
)
